module.exports = "/images/pf.svg?7cd89762eb3b07abf7b3d89c246c8206";